import { render, staticRenderFns } from "./campaign-import-teams-v2.vue?vue&type=template&id=8997f478&scoped=true&"
import script from "./campaign-import-teams-v2.vue?vue&type=script&lang=js&"
export * from "./campaign-import-teams-v2.vue?vue&type=script&lang=js&"
import style0 from "./campaign-import-teams-v2.vue?vue&type=style&index=0&id=8997f478&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8997f478",
  null
  
)

export default component.exports